var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.777,
    height: 14.555,
    viewBox: "0 0 19.777 14.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3138",
    "data-name": "Rectangle 3138",
    width: 14.338,
    height: 14.555,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12156",
    "data-name": "Group 12156",
    transform: "translate(-42.197 -98.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12155",
    "data-name": "Group 12155",
    transform: "translate(35.197 92.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9257",
    "data-name": "Group 9257",
    transform: "translate(7 6)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M14.326,1.133A1.317,1.317,0,0,0,13.283.02a1.571,1.571,0,0,0-.95.162c-1.034.47-2.066.947-3.1,1.421L4.963,3.566.861,5.451a1.472,1.472,0,0,0-.685.595A1.352,1.352,0,0,0,.861,7.968c.238.092.484.166.729.239q1.7.5,3.409,1c.053.016.1.028.11.1q.271,1.245.548,2.488c.13.585.257,1.171.4,1.752A1.357,1.357,0,0,0,7.4,14.555a1.238,1.238,0,0,0,1.075-.609,2.664,2.664,0,0,0,.137-.252q.427-.9.851-1.792.609-1.285,1.218-2.57c.256-.539.516-1.076.773-1.614q.305-.64.607-1.281l1.217-2.571q.44-.931.883-1.861a1.508,1.508,0,0,0,.168-.873m-1.112.316c-.15.327-.306.652-.46.978L10.05,8.14,7.642,13.229a1,1,0,0,1-.051.1.262.262,0,0,1-.487-.059c-.059-.235-.113-.47-.166-.706-.1-.445-.2-.89-.3-1.335-.146-.655-.291-1.31-.44-1.964h0A1.579,1.579,0,0,0,5.151,8.128h0L5.124,8.12l-.015,0Q3.852,7.74,2.592,7.367L1.371,7.006a.353.353,0,0,1-.262-.179.251.251,0,0,1,.127-.341c.173-.088.35-.167.527-.248L4.048,5.189,6.373,4.122l3.481-1.6,3.029-1.393c.173-.079.329-.024.363.137a.322.322,0,0,1-.032.184",
    transform: "translate(0 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M117.635,125.248l-.932.933q-.7.7-1.408,1.4c-.057.056-.1.1-.076.189.015.066.03.133.045.2a1.579,1.579,0,0,0-1.049-1.132l.151.045a.167.167,0,0,0,.188-.049q.732-.738,1.468-1.473.427-.428.854-.856a.565.565,0,0,1,.378-.189.556.556,0,0,1,.547.4.532.532,0,0,1-.165.529",
    transform: "translate(-109.065 -118.711)",
    fill: "#0094d1"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-check",
    "data-name": "Icon feather-check",
    d: "M12.431,9,8.01,13.421,6,11.411",
    transform: "translate(48.624 97.378)",
    fill: "none",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendedIcon);
export default __webpack_public_path__ + "static/media/sended-icon.8142762e785b415912a6d9e16dc4fb4e.svg";
export { ForwardRef as ReactComponent };